import { createContext } from 'use-context-selector';

interface GridRowContextProps {
  spacing: number;
}

export const GridRowContext = createContext<GridRowContextProps>({
  spacing: 0,
});
